module.exports = ".required{\n  color: red;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ticket-view/modals/assign-ticket-modal/assign-ticket-modal.component.css
// module id = ./src/app/ticket-view/modals/assign-ticket-modal/assign-ticket-modal.component.css
// module chunks = main